import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { SeatRestrictedModal } from 'components/SeatRestrictedModal';
import { useLimitedPlanInfo } from 'utils/useLimitedPlanInfo';

interface SeatRestrictedRouteProps {
  children: ReactNode;
}

/**
 * Blocks seat users from billing/upgrade pages they could reach directly by
 * URL. The CTAs to these pages are already hidden for seats; this is the
 * defense-in-depth stop if one is bypassed. Waits for account data so
 * non-seats are never blocked while it loads.
 */
export function SeatRestrictedRoute({ children }: SeatRestrictedRouteProps) {
  const navigate = useNavigate();
  const { accountLoaded, isSeat } = useLimitedPlanInfo();

  if (accountLoaded && isSeat) {
    return (
      <SeatRestrictedModal onGoToDashboard={() => navigate('/dashboard')} />
    );
  }

  return <>{children}</>;
}
